import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { ChakraProvider, Box } from '@chakra-ui/react';
import { chakraUiTheme } from '@everfi/design-system';
import { CacheProvider } from '@emotion/react';
import createCache from '@emotion/cache';

export const ChakraUIProvider = ({ children, theme = chakraUiTheme }) => {
  const [oneRender, setOneRender] = useState(false);
  useEffect(() => setOneRender(true), []);
  const serverSide = typeof window === 'undefined';

  if (serverSide || !oneRender) {
    const cache = createCache({ key: 'custom' });
    return <CacheProvider value={cache}>{children}</CacheProvider>;
  }

  return (
    <ChakraProvider resetCSS={true} theme={theme}>
      <Box>{children}</Box>
    </ChakraProvider>
  );
};

ChakraUIProvider.propTypes = {
  children: PropTypes.node,
  theme: PropTypes.object,
};
